/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';
import type { GovernorateEnum } from './GovernorateEnum';
import {
    GovernorateEnumFromJSON,
    GovernorateEnumFromJSONTyped,
    GovernorateEnumToJSON,
} from './GovernorateEnum';
import type { SexEnum } from './SexEnum';
import {
    SexEnumFromJSON,
    SexEnumFromJSONTyped,
    SexEnumToJSON,
} from './SexEnum';
import type { SpecialtiesEnum } from './SpecialtiesEnum';
import {
    SpecialtiesEnumFromJSON,
    SpecialtiesEnumFromJSONTyped,
    SpecialtiesEnumToJSON,
} from './SpecialtiesEnum';
import type { SubSpecialtiesEnum } from './SubSpecialtiesEnum';
import {
    SubSpecialtiesEnumFromJSON,
    SubSpecialtiesEnumFromJSONTyped,
    SubSpecialtiesEnumToJSON,
} from './SubSpecialtiesEnum';

/**
 * 
 * @export
 * @interface AddedRequestedData
 */
export interface AddedRequestedData {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof AddedRequestedData
     */
    medicalLicenseFront?: FileSchemaIn;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof AddedRequestedData
     */
    medicalLicenseBack?: FileSchemaIn;
    /**
     *
     * @type {string}
     * @memberof AddedRequestedData
     */
    fullName?: string;
    /**
     * 
     * @type {SpecialtiesEnum}
     * @memberof AddedRequestedData
     */
    specialty?: SpecialtiesEnum;
    /**
     * 
     * @type {SubSpecialtiesEnum}
     * @memberof AddedRequestedData
     */
    subSpecialty?: SubSpecialtiesEnum;
    /**
     * 
     * @type {SexEnum}
     * @memberof AddedRequestedData
     */
    sex?: SexEnum;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof AddedRequestedData
     */
    clinicLicensePhoto?: FileSchemaIn;
    /**
     * 
     * @type {GovernorateEnum}
     * @memberof AddedRequestedData
     */
    governorate?: GovernorateEnum;
    /**
     * 
     * @type {string}
     * @memberof AddedRequestedData
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof AddedRequestedData
     */
    clinicLicenseNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddedRequestedData
     */
    taxNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof AddedRequestedData
     */
    phoneNumber1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddedRequestedData
     */
    phoneNumber2?: string;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof AddedRequestedData
     */
    clinicOutsidePhoto?: FileSchemaIn;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof AddedRequestedData
     */
    clinicInsidePhoto?: FileSchemaIn;
}

/**
 * Check if a given object implements the AddedRequestedData interface.
 */
export function instanceOfAddedRequestedData(value: object): boolean {
    return true;
}

export function AddedRequestedDataFromJSON(json: any): AddedRequestedData {
    return AddedRequestedDataFromJSONTyped(json, false);
}

export function AddedRequestedDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddedRequestedData {
    if (json == null) {
        return json;
    }
    return {
        
        'medicalLicenseFront': json['medical_license_front'] == null ? undefined : FileSchemaInFromJSON(json['medical_license_front']),
        'medicalLicenseBack': json['medical_license_back'] == null ? undefined : FileSchemaInFromJSON(json['medical_license_back']),
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'specialty': json['specialty'] == null ? undefined : SpecialtiesEnumFromJSON(json['specialty']),
        'subSpecialty': json['sub_specialty'] == null ? undefined : SubSpecialtiesEnumFromJSON(json['sub_specialty']),
        'sex': json['sex'] == null ? undefined : SexEnumFromJSON(json['sex']),
        'clinicLicensePhoto': json['clinic_license_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_license_photo']),
        'governorate': json['governorate'] == null ? undefined : GovernorateEnumFromJSON(json['governorate']),
        'address': json['address'] == null ? undefined : json['address'],
        'clinicLicenseNumber': json['clinic_license_number'] == null ? undefined : json['clinic_license_number'],
        'taxNumber': json['tax_number'] == null ? undefined : json['tax_number'],
        'phoneNumber1': json['phone_number1'] == null ? undefined : json['phone_number1'],
        'phoneNumber2': json['phone_number2'] == null ? undefined : json['phone_number2'],
        'clinicOutsidePhoto': json['clinic_outside_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_outside_photo']),
        'clinicInsidePhoto': json['clinic_inside_photo'] == null ? undefined : FileSchemaInFromJSON(json['clinic_inside_photo']),
    };
}

export function AddedRequestedDataToJSON(value?: AddedRequestedData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'medical_license_front': FileSchemaInToJSON(value['medicalLicenseFront']),
        'medical_license_back': FileSchemaInToJSON(value['medicalLicenseBack']),
        'full_name': value['fullName'],
        'specialty': SpecialtiesEnumToJSON(value['specialty']),
        'sub_specialty': SubSpecialtiesEnumToJSON(value['subSpecialty']),
        'sex': SexEnumToJSON(value['sex']),
        'clinic_license_photo': FileSchemaInToJSON(value['clinicLicensePhoto']),
        'governorate': GovernorateEnumToJSON(value['governorate']),
        'address': value['address'],
        'clinic_license_number': value['clinicLicenseNumber'],
        'tax_number': value['taxNumber'],
        'phone_number1': value['phoneNumber1'],
        'phone_number2': value['phoneNumber2'],
        'clinic_outside_photo': FileSchemaInToJSON(value['clinicOutsidePhoto']),
        'clinic_inside_photo': FileSchemaInToJSON(value['clinicInsidePhoto']),
    };
}

